import React, { Fragment, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ROUTE_HOME } from 'routes';

import {
  getCurrentSection,
  getCurrentSubsection,
  getNextSection,
  getPreviousSection,
} from 'helpers/navigationHelper';
import { ThemeProvider } from '@material-ui/core';

import SubHeader from 'components/organisms/SubHeader/SubHeader';
import SvgIcon from 'components/atoms/SvgIcon/SvgIcon';
import SectionNavigation from 'components/molecules/SectionNavigation/SectionNavigation';
import SubsectionNavigation from 'components/molecules/SubsectionNavigation/SubsectionNavigation';
import Box from 'components/atoms/Box/Box';

import { MainLogo, LandingSubHeaderBackground } from 'assets/imageList';
import Typography from 'components/atoms/Typography/Typography';
import { useTranslation } from 'react-i18next';

export default function AppNavigation(props) {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const currentSection = getCurrentSection(location);
  const currentSubsection = getCurrentSubsection(location);

  const handleOnClickPrevious = () => {
    const previousSection = getPreviousSection(currentSection.id);
    history.push(previousSection.route);
  };
  const handleOnClickNext = () => {
    const nextSection = getNextSection(currentSection.id);
    history.push(nextSection.route);
  };
  const handleSubsectionOnClick = (subsection) => {
    history.push(subsection.route);
  };

  return (
    <Fragment>
      {location.pathname === ROUTE_HOME ? (
        <Fragment>
          <Box pt="4px" />
        </Fragment>
      ) : (
        <Fragment>
          {currentSection && currentSubsection ? (
            <ThemeProvider theme={currentSection.theme}>
              <Box pt="4px" />
              <SubHeader
                position="relative"
                backgroundImage={currentSection.subheaderBackgroundImage}
              >
                <SectionNavigation
                  title={t(currentSection.translationKey)}
                  icon={currentSection.subheaderIcon}
                  onClickPrevious={handleOnClickPrevious}
                  onClickNext={handleOnClickNext}
                />
              </SubHeader>
              {currentSubsection && (
                <SubsectionNavigation
                  items={currentSection.subsections}
                  currentSubsection={currentSubsection.id}
                  onClick={handleSubsectionOnClick}
                />
              )}
            </ThemeProvider>
          ) : (
            <Fragment />
          )}
        </Fragment>
      )}
    </Fragment>
  );
}
